import { useNavigate } from "react-router-dom";
import { IconContext } from "react-icons";
import { FaUserCircle } from "react-icons/fa";
import { BsQuestionCircle } from "react-icons/bs";

import "./style.css";
import { useAppSelector } from "../../_app";
import { useEffect, useState } from "react";
import SubmenuModal from "../modals/SubmenuModal";
import AuthHeader from "./AuthHeader";
import Logo from "../../assets/Logo.png";
import Tooltip from "../Tooltip";
import { RoleService } from "../../_service";
import { Notify } from "../../utils";
import { Constant } from "../../config";
import CustomTooltip from "../CustomTooltip";
import { IoHelpCircleOutline } from "react-icons/io5";
import { Avatar } from "@mui/material";
import { IoMdNotificationsOutline } from "react-icons/io";
import HeaderNotificationPopup from "../HeaderNotificationPopup";
import { NotificationService } from "../../_service/NotificationService";

const Header = () => {
  const navigate = useNavigate();

  const user = useAppSelector((state) => state.user);
  console.log("user",user?.employee_id);
  
  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState([])
  const [notification, setNotifications] = useState(0)
  const [drawerOpen, setDrawerOpen] = useState(false);

  const getUserGroups = async () => {
    try {
      const { data, status } = await RoleService._getRoles(0);

      if (status === 200) {
        setGroups(() =>
          data.map((dataObj: any) => ({
            name: dataObj.name,
          })),
        );
      }
    } catch (error) {
      console.log("error", error);
      // Notify(Constant.common.something_went_wrong, 0);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await NotificationService._getNotification(false, 1, 1000, user.employee_id);
      setNotifications(res?.data?.count);
    } catch(err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getUserGroups();
    fetchNotifications();
  }, []);

  const handleCloseDrawer = () => {
  setDrawerOpen(false);
  fetchNotifications(); 
};

  console.log("groups", groups);
  console.log("usergroup", user.groups)

  const handleSwitchCompany = () => {
    navigate("manage-company");
  };
  console.log("menu", user.groups);

  return (
    <div className="header-wrapper">
      <SubmenuModal open={open} close={() => setOpen(false)} />
      <div className="section">
        <p className="company-name">
          {user.defaultCompany ? user.defaultCompany : user.name}
        </p>
        <button className="company-btn" onClick={handleSwitchCompany}>
          switch
        </button>
      </div>
      <div className="section left">
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: ".5rem",
              width: 250,
            }}
          >
            <img
              style={{ width: "80%" }}
              src={Logo}
              alt="salary pay logo"
            />
            <div style={{ padding: "0rem .8rem" }}>
              <CustomTooltip title="Help Docs" arrow placement="top">
                <a
                  href="https://live.salarypay.sg/help"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: "inline-block" }}
                >
                  <IoHelpCircleOutline color="white" size={35} />
                </a>
              </CustomTooltip>
            </div>

          </div>
          {/* <button className="company-btn" onClick={handleSwitchCompany} title="Switch Company">
            <p className="company-name">
              {user.defaultCompany ? user.defaultCompany : user.name}
            </p>
          </button> */}


        </div>
        {/* <div
          style={{
            position: "relative",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "5px",
          }}
          onClick={() => setDrawerOpen(true)}
        >
          <IoMdNotificationsOutline color="white" size={25} />

          {notification > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                minWidth: "18px",
                height: "18px",
                padding: "0 5px",
                borderRadius: "999px",
                backgroundColor: "#e53935",
                color: "#fff",
                fontSize: "11px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
              }}
            >
              {notification > 99 ? "99+" : notification}
            </span>
          )}

        </div> */}

        <div
          style={{
            color: "#ebd369",
            textAlign: "center",
            margin: "0rem .4rem",
          }}
        >
          {/* User Email */}
          <p
            style={{
              fontSize: ".9rem",
              fontWeight: "600",
            }}
          >
            {user.email}
          </p>

          {/* User Groups */}
          <CustomTooltip title={user.groups.map((group: any) => group.name).join(", ")} placement={"bottom"} >

            <p style={{
              display: 'flex',
              textAlign: "center"

            }}>

              <span
                style={{
                  fontSize: ".8rem",
                  color: "#fff",
                  alignItems: "center",
                  paddingLeft: "15px"
                }}
              >
                {/* Display the first two groups */}
                {user.groups.slice(0, 3).map((group: any) => group.name).join(", ")}
              </span>
              {user.groups.length > 3 && (

                <span
                  style={{
                    fontSize: ".8rem",
                    color: "#fff",
                    width: 'max-content',
                    zIndex: 1,
                  }}
                >

                  <p>....</p>
                </span>
              )}
            </p>
          </CustomTooltip>



        </div>

        <div
          style={{
            position: "relative",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "5px",
          }}
          onClick={() => setDrawerOpen(true)}
        >
          <IoMdNotificationsOutline color="white" size={25} />

          {notification > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-4px",
                right: "-6px",
                minWidth: "18px",
                height: "18px",
                padding: "0 5px",
                borderRadius: "999px",
                backgroundColor: "#e53935",
                color: "#fff",
                fontSize: "11px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
              }}
            >
              {notification > 99 ? "99+" : notification}
            </span>
          )}

        </div>
        {/* <div className="navbar-icon-wrap">
          <IconContext.Provider value={{ color: "#BDBDBD", size: "1.5rem" }}>
            <BsQuestionCircle />
          </IconContext.Provider>
        </div> */}
        {user.profile_image ? <Avatar sizes="1.5rem" alt="profile" className="no-btn p-4" src={user.profile_image} onClick={() => setOpen((_) => !_)} /> :
          <div className="navbar-icon-wrap">
            <button className="no-btn" onClick={() => setOpen((_) => !_)}>
              <IconContext.Provider value={{ color: "#BDBDBD", size: "1.5rem" }}>
                <FaUserCircle />
              </IconContext.Provider>
            </button>
          </div>
        }

        <HeaderNotificationPopup
          open={drawerOpen}
          onClose={handleCloseDrawer}
        />


      </div>
    </div>
  );
};

export default Header;
export { AuthHeader };
